import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import styles from "./style.module.scss"

const useCatalogTable = (data, tableConfig) => {
    return (
        <DataTable className={styles.dataTable} value={data}>
            {tableConfig.map(({ field, header, hidden = false }) => (
                <Column key={field}
                        field={field}
                        header={header}
                        hidden={hidden}
                        headerClassName={styles.tableHeader}
                        bodyClassName={`${styles.tableColumn} ${field === "id" ? styles.idColumn : styles.mainDataColumn}`}
                >
                </Column>
            ))}
        </DataTable>
    )
}

export default useCatalogTable;